import { useEffect, useState } from "react";

const navLinks = [
  { id: "today", label: "今日热门" },
  { id: "week", label: "本周排行" },
  { id: "features", label: "爆款话题" },
  { id: "columns", label: "栏目分类" },
  { id: "about", label: "关于我们" },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);
  const [query, setQuery] = useState("");

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const handleSearch = (e: React.FormEvent) => {
    e.preventDefault();
    if (!query.trim()) return;
    document.getElementById("today")?.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <header
      className={`fixed inset-x-0 top-0 z-50 transition-all duration-300 ${
        scrolled
          ? "bg-background-50/95 backdrop-blur-md border-b border-background-200"
          : "bg-transparent border-b border-transparent"
      }`}
    >
      <div className="mx-auto flex max-w-7xl items-center justify-between px-4 md:px-6 h-16 md:h-[72px]">
        <a href="#home" className="flex items-center gap-2.5">
          <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-primary-500 text-background-50">
            <i className="ri-flashlight-fill text-lg"></i>
          </span>
          <span className="font-display text-xl md:text-2xl text-foreground-950 tracking-wide whitespace-nowrap">
            吃瓜<span className="text-primary-600">精选</span>
          </span>
        </a>

        <nav className="hidden lg:flex items-center gap-1" aria-label="主导航">
          {navLinks.map((link) => (
            <a
              key={link.id}
              href={`#${link.id}`}
              className="px-3.5 py-2 text-sm font-medium text-foreground-700 whitespace-nowrap rounded-md hover:text-primary-600 hover:bg-primary-50 transition-colors"
            >
              {link.label}
            </a>
          ))}
        </nav>

        <div className="hidden md:flex items-center gap-3">
          <form onSubmit={handleSearch} className="relative">
            <input
              type="search"
              value={query}
              onChange={(e) => setQuery(e.target.value)}
              placeholder="搜热点、事件、明星"
              aria-label="搜索热点"
              className="w-56 h-10 rounded-full border border-background-300 bg-background-50 pl-4 pr-10 text-sm text-foreground-900 placeholder:text-foreground-400 focus:outline-none focus:border-primary-400 focus:ring-2 focus:ring-primary-200/60 transition"
            />
            <button
              type="submit"
              aria-label="搜索"
              className="absolute right-1 top-1 flex h-8 w-8 items-center justify-center rounded-full text-foreground-500 hover:text-primary-600"
            >
              <i className="ri-search-line text-base"></i>
            </button>
          </form>
          <a
            href="#today"
            className="whitespace-nowrap inline-flex items-center gap-1.5 h-10 px-5 rounded-full bg-primary-500 text-background-50 text-sm font-semibold hover:bg-primary-600 transition-colors"
          >
            <i className="ri-fire-line"></i>
            看今日热度
          </a>
        </div>

        <button
          onClick={() => setOpen(!open)}
          aria-label="切换菜单"
          className="lg:hidden flex h-10 w-10 items-center justify-center rounded-md text-foreground-800 hover:bg-background-100"
        >
          <i className={`${open ? "ri-close-line" : "ri-menu-line"} text-2xl`}></i>
        </button>
      </div>

      {open && (
        <div className="lg:hidden bg-background-50 border-t border-background-200 px-4 pb-4 pt-2">
          <nav className="flex flex-col gap-1" aria-label="移动端导航">
            {navLinks.map((link) => (
              <a
                key={link.id}
                href={`#${link.id}`}
                onClick={() => setOpen(false)}
                className="px-3 py-3 text-sm font-medium text-foreground-800 rounded-md hover:bg-primary-50 hover:text-primary-600"
              >
                {link.label}
              </a>
            ))}
          </nav>
          <form onSubmit={handleSearch} className="mt-3 relative md:hidden">
            <input
              type="search"
              value={query}
              onChange={(e) => setQuery(e.target.value)}
              placeholder="搜热点、事件、明星"
              aria-label="搜索热点"
              className="w-full h-11 rounded-lg border border-background-300 bg-background-50 pl-4 pr-11 text-sm text-foreground-900 placeholder:text-foreground-400 focus:outline-none focus:border-primary-400"
            />
            <button
              type="submit"
              aria-label="搜索"
              className="absolute right-1.5 top-1/2 -translate-y-1/2 flex h-8 w-8 items-center justify-center text-foreground-500 hover:text-primary-600"
            >
              <i className="ri-search-line text-base"></i>
            </button>
          </form>
        </div>
      )}
    </header>
  );
}